import React from 'react';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const useStyles= makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
      padding: 0,
    },
  },
  icon: {
    borderRadius: '50%',
    width: 16,
    height: 16,

    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor:'transparent' ,
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
   },

});

// Inspired by blueprintjs
function StyledRadio(props) {
  const classes = useStyles();


  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
     // checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)}/>}
      icon={<span className={classes.icon}/>}
      {...props}
    />
  );
}
const CustomizedRadios = (props) => {
  return (
    <FormControlLabel
      control={
        <StyledRadio
          checked={props.checked}
          onChange={props.onChange}
          value={props.value}
          disabled={props.disabled}
          style={props.style}
          name={props.name}
        />}
      label={props.label}
      labelPlacement={props.labelPlacement}/>
  );
}
export default CustomizedRadios;
